export default __webpack_public_path__ + "static/media/spheres-other.5a4da5ff.mp3";